__turbopack_context__.v({
  "ctaButton": "hero_tile-module-scss-module__DOdPPW__ctaButton",
  "description": "hero_tile-module-scss-module__DOdPPW__description",
  "heroTileButtonContainer": "hero_tile-module-scss-module__DOdPPW__heroTileButtonContainer",
  "heroTileDescription": "hero_tile-module-scss-module__DOdPPW__heroTileDescription",
  "heroTileImageAndTextBackGroundContainer": "hero_tile-module-scss-module__DOdPPW__heroTileImageAndTextBackGroundContainer",
  "heroTileMainContainer": "hero_tile-module-scss-module__DOdPPW__heroTileMainContainer",
  "heroTileTitle": "hero_tile-module-scss-module__DOdPPW__heroTileTitle",
  "heroTiletextContainer": "hero_tile-module-scss-module__DOdPPW__heroTiletextContainer",
  "imageAndContentContainer": "hero_tile-module-scss-module__DOdPPW__imageAndContentContainer",
  "imagesize": "hero_tile-module-scss-module__DOdPPW__imagesize",
  "linkButton": "hero_tile-module-scss-module__DOdPPW__linkButton",
  "roomImage": "hero_tile-module-scss-module__DOdPPW__roomImage",
  "title": "hero_tile-module-scss-module__DOdPPW__title",
});
